import React, { Fragment, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import OffersListItemCoins from './OffersListItemCoins';
import OffersGeo from './OffersGeo';
import OffersPrices from './OffersPrices';
import OffersPixels from './OffersPixels';
import OffersTargets from './OffersTargets';
import { FMessage } from '../../../../hoc/IntlComponents';
import { Button } from 'reactstrap';
import { getStoreUrl } from '../../../../utils/utils';
import Hint from '../../../../components/Hint/Hint';

const collapsedItems = 3;

const getCountryString = (countries, code) => {
  const country = countries.find(country => country.id === code);

  return country && country.title;
};

const formatPrices = (prices = {}, countries) => {
  const pricesArray = Object.keys(prices).map(price => ({
    country: getCountryString(countries, price),
    price: prices[price].price,
    currency: prices[price].currency,
    code: price,
  }));

  return pricesArray.sort((a, b) => {
    if (a.country < b.country) {
      return -1;
    }
    if (a.country > b.country) {
      return 1;
    }
    return 0;
  });
};

const formatPixels = (pixels, countries) =>
  pixels.sort((a, b) => {
    const aCoutryString = getCountryString(countries, a.geo);
    const bCountryString = getCountryString(countries, b.geo);
    if (aCoutryString < bCountryString) {
      return -1;
    }
    if (aCoutryString > bCountryString) {
      return 1;
    }
    return 0;
  });

const OffersListTable = ({ prices, pixels, id, coins, countries, isPrivate, noAccess }) => {
  const [isCollapsed, toggleCollapse] = useState(true);

  const formattedPrices = formatPrices(prices, countries);
  const formattedPixel = formatPixels(pixels, countries);
  const shouldCollapse = formattedPrices.length > collapsedItems;

  // if (!shouldCollapse) {
  //   toggleCollapse(false);
  // }

  return (
    <div className="offers-list-table">
      <div className={classNames({ blur: isPrivate || noAccess, 'hidden-text': isPrivate || noAccess }, 'offers-list-inner')}>
        <div className="offers-list-table-header">
          {formattedPrices.length > 0 && (
            <Fragment>
              <div className="offers-list-table-header-item">
                <FormattedMessage id="offers.table.countries.one" defaultMessage="Country" />
              </div>

              <div className="offers-list-table-header-item">
                <FormattedMessage id="offers.table.prices" defaultMessage="Prices" />
              </div>
            </Fragment>
          )}
          <div className="offers-list-table-header-item text-right">
            <FormattedMessage id="offers.table.withholdings" defaultMessage="Withholdings" />
          </div>
          {coins > 0 && (
            <div className="offers-list-table-header-item offers-list-table-header-item--coins">
              <FormattedMessage id="offers.table.coins" defaultMessage="Coins" />
              <Hint
                title={<FMessage id="offer.tooltip.header" />}
                className="coins-hint"
                id={`coin-hint-${id}`}
                placement="right"
                delay={250}
              >
                <FormattedMessage
                  id="offer.tooltip.p"
                  defaultMessage="According to this offer,  {coins, plural, one {# coin} other {# coins} } is charged for a confirmed application. Coins you can spend on "
                  values={{
                    coins,
                  }}
                />
                <a href={getStoreUrl()} target="_blank">
                  <FMessage id="offer.tooltip.link-to-store" />
                </a>
              </Hint>
            </div>
          )}

          <div className="offers-list-table-header-item offers-list-table-header-item--targets">
            <FormattedMessage id="offers.table.targets" defaultMessage="Targets" />
          </div>
        </div>
        <div
          className={
            shouldCollapse && isCollapsed
              ? 'offers-list-table-body offers-list-table-body--collapse'
              : 'offers-list-table-body'
          }
        >
          <OffersGeo
            prices={formattedPrices}
            isCollapsed={isCollapsed}
            id={id}
            collapsedItems={collapsedItems}
          />
          <OffersPrices
            prices={formattedPrices}
            isCollapsed={isCollapsed}
            id={id}
            collapsedItems={collapsedItems}
          />
          <OffersPixels
            pixels={formattedPixel}
            isCollapsed={isCollapsed}
            collapsedItems={collapsedItems}
          />
          <OffersListItemCoins
            coins={coins}
            pixels={formattedPixel}
            isCollapsed={isCollapsed}
            collapsedItems={collapsedItems}
            id={id}
          />
          <OffersTargets
            pixels={formattedPixel}
            isCollapsed={isCollapsed}
            collapsedItems={collapsedItems}
            id={id}
          />
        </div>
        {shouldCollapse && (
          <Button
            className="offer-list-show-more"
            color="link"
            onClick={() => toggleCollapse(!isCollapsed)}
          >
            {isCollapsed ? (
              <FormattedMessage id="offer.geo.show-all" defaultMessage="Display all countries" />
            ) : (
              <FormattedMessage id="main.hide" defaultMessage="Hide" />
            )}
          </Button>
        )}
      </div>
      {noAccess && (
        <div className="private-access">
          <i className="icon-lock" />{' '}
          <span>
            <FormattedMessage id="offers.private-access" defaultMessage="Private access" />
          </span>
        </div>
      )}
    </div>
  );
};

export default OffersListTable;
